import {
  OrderPdfStatus,
  OrderReservationStatus,
  OrderStatus
} from './order-status.model';

/** Snapshot de OS anidado en un servicio de programación (getProgrammingServicesAndOrdersByFile). */
export interface ServiceOrder {
  orderId?: string | null;
  orderNumber?: string | null;
  /** P-{orderNumber} mientras la OS es preliminar. */
  displayCode?: string | null;
  orderStatus?: OrderStatus | string | null;
  reservationNumber?: string | null;
  reservationStatus?: OrderReservationStatus | string | null;
  orderObservation?: string | null;
  scheduledPaymentDate?: string | null;
  freezeDeadlineAt?: string | null;
  paidAt?: string | null;
  pdfStatus?: OrderPdfStatus | string | null;
  pdfGeneratedAt?: string | null;
  lastPdfError?: string | null;
  /** true si el monto/pax ya se ajustó automáticamente al menos una vez. */
  autoAdjusted?: boolean | null;
  /** ISO del último recálculo automático. */
  lastRecalculatedAt?: string | null;
  /** Presente en OS multi-línea / tickets; útil al eliminar para refrescar padres. */
  serviceIds?: string[] | null;
}

export interface OrderRecalcLineDelta {
  orderLineId: string;
  serviceId: string;
  previousAmount: number;
  newAmount: number;
  previousPax?: number | null;
  newPax?: number | null;
}

export interface OrderRecalcHistoryItem {
  historyId: string;
  orderId: string;
  trigger: string;
  source: string;
  previousTotal: number;
  newTotal: number;
  changedAt: string;
  lineDeltas?: OrderRecalcLineDelta[] | null;
}

export function getServiceOrderId(
  service: { order?: ServiceOrder | null } | null | undefined
): string | null {
  return service?.order?.orderId ?? null;
}
